import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import modules from "./modules";
import mutations from "./mutations";
import state from "./state";
import { auth } from "./auth.module";
import { navbar } from "./navbar.module";
import { data } from "./data.module";
import { applicationUsers } from "./applicationUsers.module";
import { common } from "./common.module";
import { plansMembers } from "./plansMembers.module";
import { transactions } from "./transactions.module";
import { monitoring } from "./monitoring.module";
import { downloadCenter } from "./downloadCenter.module";
import {documentsService} from "./documentsService.module";
import { portalsProxy } from "./portalsProxy.module";
import { claims } from "./claims.module";
import { redmine } from "./redmine.module";
import { optouts } from './optouts.module';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    documentsService: documentsService,
    actions,
    getters,
    modules,
    mutations,
    state,
    auth: auth,
    navbar: navbar,
    data: data,
    applicationUsers: applicationUsers,
    common: common,
    plansMembers: plansMembers,
    transactions: transactions,
    monitoring: monitoring,
    downloadCenter,
    portalsProxy,
    claims,
    redmine,
    optouts,
  },
});

export default store;
